import styles from "./styles.module.scss";
import classnames from "classnames";
import Hamburger from "hamburger-react";
import { useEffect, useRef, useState } from "react";

interface HeaderProps {
  fullWidth?: boolean;
  scrollToRef: (ref: React.RefObject<HTMLElement>) => void;
  aboutRef: React.RefObject<HTMLElement>;
  mainRef: React.RefObject<HTMLElement>;
  featuresRef: React.RefObject<HTMLElement>;
  contactsRef: React.RefObject<HTMLElement>;
  activeSection: string;
}

const navItems = ["Главная", "О нас", "Компоненты", "Контакты"];
export const Header: React.FC<HeaderProps> = ({
  fullWidth = false,
  scrollToRef,
  aboutRef,
  featuresRef,
  contactsRef,
  mainRef,
  activeSection,
}) => {
  // const [activeButton, setActiveButton] = useState<string>('Главная');
  const [isOpen, setOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        isOpen
      ) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setOpen]);

  const onNavChange = (item: string) => {
    // setActiveButton(item);
    switch (item) {
      case "Главная":
        // Прокрутка к верху страницы
        // window.scrollTo({ top: 0, behavior: 'smooth' });
        scrollToRef(mainRef);
        break;
      case "О нас":
        scrollToRef(aboutRef);
        break;
      case "Компоненты":
        scrollToRef(featuresRef);
        break;
      case "Контакты":
        scrollToRef(contactsRef);
        break;
      default:
        break;
    }
  };

  return (
    <div className={styles.header} ref={menuRef}>
      <div className={styles.desktopMenu}>
        <div className={styles.logo}>
          <div className={styles.logotitle}>КиберФит</div>
          <div className={styles.logotext}>
            EST. 2025 | революция на стыке геймификации и фитнеса
          </div>
        </div>{" "}
        <div
          className={`${styles.line} ${fullWidth ? "" : styles.fullWidth}`}
        />
        <nav className={styles.buttonsholder}>
          {navItems.map((item) => (
            <div
              className={classnames(
                styles.button,
                activeSection === item ? styles.active : ""
              )}
              onClick={() => onNavChange(item)}
            >
              {item}
            </div>
          ))}
        </nav>
        <div
          className={`${styles.line} ${fullWidth ? "" : styles.fullWidth}`}
        />
      </div>
      <div className={styles.mobileMenuContainer}>
        <div className={styles.logoholder}>
          <div className={styles.logo}>
            <div className={styles.logotitle}>КиберФит</div>
            <div className={styles.logotext}>
              EST. 2025 | революция на стыке геймификации и фитнеса
            </div>
          </div>{" "}
          <div className={styles.hamburgerholder}>
            <Hamburger
              toggled={isOpen}
              toggle={setOpen}
              color="black"
              size={30}
            />
          </div>
        </div>
        <div
          className={classnames(
            styles.mobileMenu,
            isOpen ? styles.mobileMenuOpen : styles.mobileMenuClosed
          )}
        >
          <nav className={styles.mobileButtonsholder}>
            {navItems.map((item) => (
              <div
                key={item}
                className={classnames(
                  styles.mobileButton,
                  activeSection === item ? styles.active : ""
                )}
                onClick={() => {
                  onNavChange(item);
                  setOpen(false); // Закрываем меню после выбора
                }}
              >
                {item}
              </div>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
};
